import Toast from 'react-bootstrap/Toast';
import './Toast.css';

export const ToastService = ({ message }) => {
  return (
    <div className="toast-container">
        <Toast show={true} autohide={false}>
            <Toast.Body>{message}</Toast.Body>
        </Toast>
    </div>    
  );
}
